import { render, staticRenderFns } from "./PageCard.vue?vue&type=template&id=fd2c8270&scoped=true"
import script from "./PageCard.vue?vue&type=script&lang=ts"
export * from "./PageCard.vue?vue&type=script&lang=ts"
import style0 from "./PageCard.scss?vue&type=style&index=0&id=fd2c8270&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2c8270",
  null
  
)

export default component.exports